<template>
  <div
    class="direct-container direct_my"
    v-loading.fullscreen.lock="loading"
    :style="{
      overflow: full ? 'hidden' : 'auto',
      position: full ? 'fixed' : 'static',
      top: 0,
      left: 0,
    }"
  >
    <div v-if="noData == 'false'">
      <div
        class="signup"
        :style="{
          height:
            currentBaseInfo.identity == '4' ||
            currentBaseInfo.identity == '5' ||
            !btnHidden()
              ? '100vh'
              : 'calc(100vh - 80px)',
        }"
        v-if="!open && !openDistrubute"
      >
        <!-- 头部信息 -->
        <activityHeader
          :statusText="
            currentBaseInfo.identity == '2' ? statusText + getPeopleFn() : ''
          "
          :textList="textList"
          :textObj="textObj"
          v-if="!(openDistrubute || open)"
        />

        <!-- 活动分组 -->
        <div class="direct-group">
          <div class="group">
            <img src="@/images/activity_num.png" />
            <div class="label">分组</div>
            <div class="value">{{ group || "无" }}</div>
          </div>
          <div class="group number">
            <img src="@/images/activity_type.png" />
            <div class="label">人数</div>
            <div class="value">
              {{ getActivityInfo.maxPlayers == 0 ? "不限制" : groupLitmit }}
            </div>
          </div>
        </div>

        <div class="dept-list" style="margin-bottom: 10px">
          <span
            v-for="item in groupDeptsList"
            :key="item.deptId"
            @click="handleDeptsChange(item.deptId, item)"
            :class="selDeptId == item.deptId ? 'active' : ''"
            >{{ item.deptName }}</span
          >
        </div>

        <!-- 某一个科室无报名人员的展示 -->
        <!-- <section class="direct-group">
        <p style="padding: 20px 0;">暂无报名人员</p>
        </section>-->

        <!-- 需报名-无分组-分会组长-能够报名 -->
        <div
          class="direct-group-person"
          v-if="
            currentBaseInfo.identity == '2' && getActivityInfo.groupStatus == 0
          "
        >
          <div class="direct-group">
            <div class="group" style="border: 0">
              <span class="label">报名</span>
              <div class="right-side">
                <!-- 分会主席查看按人员报名的活动 -->
                <p
                  class="limit-nogroup"
                  v-if="currentBaseInfo.identity == '2' && signType == '0'"
                >
                  已报
                  <span style="color: #38c7c4">{{
                    Number(
                      signUpGroups.signedUser && signUpGroups.signedUser.length
                    )
                  }}</span
                  >人
                </p>

                <p class="limit-nogroup" v-else>
                  已报
                  <span style="color: #38c7c4">{{
                    Number(
                      signUpGroups.signedUser && signUpGroups.signedUser.length
                    )
                  }}</span
                  >人,可报
                  <span style="color: #ff5959">{{
                    signUpGroups.groupLimit -
                    Number(
                      signUpGroups.signedUser && signUpGroups.signedUser.length
                    )
                  }}</span>
                  <!-- <span
                    style="color:#FF5959"
                  >{{getPeopleFn()}}</span> -->
                  人
                </p>

                <!-- <span
                class="sino-revise"
                @click="revise"
                v-if="currentBaseInfo.identity=='2'&&!isRevise&&signUpGroups.signedUser&&signUpGroups.signedUser.length"
              >
                <i class="el-icon-edit"></i>修改
                </span>-->
              </div>
            </div>
            <!-- 默认 -->
            <div class="names" v-if="!isRevise">
              <section
                v-if="signUpGroups.signedUser && signUpGroups.signedUser.length"
              >
                <span
                  v-for="(item, index) in signUpGroups.signedUser"
                  :key="item.staffId"
                  class="nameDefault"
                >
                  <span class="text">{{
                    index !== signUpGroups.signedUser.length - 1
                      ? item.staffName + "、"
                      : item.staffName
                  }}</span>
                </span>
              </section>
              <span v-else>暂无报名人员</span>
            </div>

            <!-- 修改 -->
            <div class="names" v-if="isRevise">
              <section
                v-if="
                  signUpGroups.signedUser && signUpGroups.signedUser.length > 0
                "
              >
                <span
                  v-for="item in signUpGroups.signedUser"
                  :key="item.staffId"
                  class="name"
                >
                  <span class="text">{{ item.staffName }}</span>
                  <span class="icon" @click="deleteByGroupLeader(item)">
                    <i class="cubeic-wrong"></i>
                  </span>
                </span>
              </section>
              <span v-else>暂无报名人员</span>
            </div>
          </div>
        </div>

        <!-- 需报名参加-有分组-分会组长-能够报名 -->
        <div
          class="direct-group-person"
          v-else-if="
            currentBaseInfo.identity == '2' && getActivityInfo.groupStatus == 1
          "
        >
          <div class="panel" v-for="item in signUpGroups" :key="item.groupId">
            <div class="panel-item">
              <div
                class="item-radio"
                @click="selectGroupByDept(item)"
                v-if="currentBaseInfo.identity == '2'"
              >
                <cube-checkbox
                  :value="item.checked"
                  :option="groupsOption"
                ></cube-checkbox>
              </div>
              <div class="item-info">
                <div class="info-title">
                  <span class="title">{{ item.groupName }}</span>
                  <div class="rightSide" v-if="item.signupByDept == '1'">
                    <span class="limit">
                      已报
                      <span style="color: #38c7c4">{{
                        item.signedUser && item.signedUser.length
                      }}</span
                      >人, 可报
                      <span style="color: #ff5959">{{
                        item.groupLimit - item.signedUser.length
                      }}</span
                      >人
                    </span>
                    <!-- <span
                    class="sino-revise"
                    @click="reviseGroup(item)"
                    v-if="currentBaseInfo.identity =='2' && reviseGroupId!=item.groupId "
                  >
                    <i class="el-icon-edit"></i>修改
                    </span>-->
                  </div>
                  <div class="rightSide" v-if="item.signupByDept == 0">
                    <span class="limit">
                      已报
                      <span style="color: #38c7c4">{{
                        item.signedUser && item.signedUser.length
                      }}</span
                      >人
                    </span>
                    <!-- <span
                    class="sino-revise"
                    @click="reviseGroup(item)"
                    v-if="currentBaseInfo.identity =='2' && reviseGroupId!=item.groupId "
                  >
                    <i class="el-icon-edit"></i>修改
                    </span>-->
                  </div>
                </div>

                <div v-if="reviseGroupId != item.groupId">
                  <section v-if="item.signedUser.length" class="names">
                    <span
                      v-for="(ele, index) in item.signedUser"
                      :key="ele.staffId"
                      class="nameDefault"
                    >
                      <span class="text">{{
                        index !== item.signedUser.length - 1
                          ? ele.staffName + "、"
                          : ele.staffName
                      }}</span>
                    </span>
                  </section>
                  <span v-else class="no-sign">暂无报名人员</span>
                </div>

                <!-- 修改的名字 -->
                <div class="names" v-if="reviseGroupId == item.groupId">
                  <span
                    v-for="ele in item.signedUser"
                    :key="ele.staffId"
                    class="name"
                  >
                    <span class="text">{{ ele.staffName }}</span>
                    <span class="icon" @click="detele(ele, item)">
                      <i class="cubeic-wrong"></i>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 需报名-无分组-分会主席-能够报名 -->
        <div
          class="direct-group-person"
          v-if="
            currentBaseInfo.identity == '3' && getActivityInfo.groupStatus == 0
          "
        >
          <div class="direct-group" v-for="ele in groups" :key="ele.groupId">
            <div class="group" style="border: 0">
              <span class="label">报名</span>
              <div class="right-side">
                <p
                  class="limit-nogroup"
                  v-if="
                    getActivityInfo.groupStatus == '0' &&
                    getActivityInfo.groupList[0].maxNum != '0'
                  "
                >
                  已报
                  <span style="color: #38c7c4">{{ signupStaffLength }}</span
                  >人,可报
                  <span style="color: #ff5959">{{
                    groupLitmit - signupStaffLength
                  }}</span
                  >人
                </p>
                <!-- <span
                class="sino-revise"
                @click="revise"
                v-if="currentBaseInfo.identity=='3'&&!isRevise"
              >
                <i class="el-icon-edit"></i>修改
                </span>-->
              </div>
            </div>
            <!-- 默认 -->
            <div class="names" v-if="!isRevise">
              <span
                v-for="(item, index) in ele.signupStaff"
                :key="item.staffId"
                class="nameDefault"
              >
                <span class="text">{{
                  index !== ele.signupStaff.length - 1
                    ? item.staffName + "、"
                    : item.staffName
                }}</span>
              </span>
            </div>

            <!-- 修改 -->
            <div class="names" v-if="isRevise">
              <span
                v-for="item in ele.signupStaff"
                :key="item.staffId"
                class="name"
              >
                <span class="text">{{ item.staffName }}</span>
                <span class="icon" @click="detele(item, ele)">
                  <i class="cubeic-wrong"></i>
                </span>
              </span>
            </div>
          </div>
        </div>

        <!-- 需报名参加-有分组-分会主席-能够报名 -->
        <div
          class="direct-group-person"
          v-else-if="
            currentBaseInfo.identity == '3' && getActivityInfo.groupStatus == 1
          "
        >
          <div class="panel" v-for="item in groups" :key="item.unionId">
            <div class="panel-item">
              <div
                class="item-radio"
                @click="selectGroup(item)"
                v-if="currentBaseInfo.identity == '3'"
              >
                <cube-checkbox
                  :value="item.checked"
                  :option="groupsOption"
                ></cube-checkbox>
              </div>
              <div class="item-info">
                <div class="info-title">
                  <span class="title">{{ item.groupName }}</span>
                  <div class="rightSide">
                    <span class="limit">
                      已报
                      <span style="color: #38c7c4">{{
                        item.signupStaff.length
                      }}</span
                      >人, 可报
                      <span style="color: #ff5959">{{
                        item.maxNum - item.signupStaff.length
                      }}</span
                      >人
                    </span>
                    <!-- <span
                    class="sino-revise"
                    @click="reviseGroup(item)"
                    v-if="currentBaseInfo.identity =='3' && reviseGroupId!=item.groupId "
                  >
                    <i class="el-icon-edit"></i>修改
                    </span>-->
                  </div>
                </div>

                <div v-if="reviseGroupId != item.groupId">
                  <section v-if="item.signupStaff.length" class="names">
                    <span
                      v-for="(ele, index) in item.signupStaff"
                      :key="ele.staffId"
                      class="nameDefault"
                    >
                      <span class="text">{{
                        index !== item.signupStaff.length - 1
                          ? ele.staffName + "、"
                          : ele.staffName
                      }}</span>
                    </span>
                  </section>
                  <span v-else class="no-sign">暂无报名人员</span>
                </div>

                <!-- 修改的名字 -->
                <div class="names" v-if="reviseGroupId == item.groupId">
                  <span
                    v-for="ele in item.signupStaff"
                    :key="ele.staffId"
                    class="name"
                  >
                    <span class="text">{{
                      index !== item.signupStaff.length - 1
                        ? ele.staffName + "、"
                        : ele.staffName
                    }}</span>
                    <span class="icon" @click="detele(ele, item)">
                      <i class="cubeic-wrong"></i>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 活动管理-无分组-不能报名 -->
        <div
          class="activity-block activity-nogroup"
          v-else-if="
            (currentBaseInfo.identity == '4' ||
              currentBaseInfo.identity == '5') &&
            getActivityInfo.groupStatus == 0
          "
        >
          <p class="title">各分会人数</p>
          <div
            class="group-item"
            v-for="item in signUpGroupList"
            :key="item.unionId"
          >
            <div class="info">
              <div @click="selectGroupManage(item)" class="group-item-flex">
                <cube-checkbox
                  :value="item.checked"
                  :option="groupsOption"
                ></cube-checkbox>
                <span class="union-name">{{ item.unionName }}</span>
              </div>
              <p class="right-side">
                <span class="limit">
                  已报
                  <span style="color: #38c7c4">{{
                    item.list[0].signupNum
                  }}</span
                  >人， 可报
                  <span style="color: #ff5959">{{ item.list[0].allowNum }}</span
                  >人
                </span>
                <span
                  v-if="selectedGroupUnionId != item.unionId"
                  class="check-btn"
                  @click="checkClose(item.unionId)"
                >
                  查看
                  <i class="el-icon-arrow-down"></i>
                </span>
                <span
                  v-if="selectedGroupUnionId == item.unionId"
                  class="check-btn"
                  @click="hiddenNames(item.unionId)"
                >
                  收起
                  <i class="el-icon-arrow-up"></i>
                </span>
              </p>
            </div>

            <div
              class="names"
              v-if="selectedGroupUnionId == item.unionId && !isRevise"
            >
              <p
                v-if="
                  item.list[0].signupStaff &&
                  item.list[0].signupStaff.length == 0
                "
              >
                暂无报名人员
              </p>
              <span
                v-else
                class="text"
                v-for="(ele, index) in item.list[0].signupStaff"
                :key="ele.staffId"
              >
                <span>{{
                  index != item.list[0].signupStaff.length - 1
                    ? ele.staffName + "、"
                    : ele.staffName
                }}</span>
              </span>
            </div>
            <!-- 修改的名字 -->
            <div
              class="names"
              v-if="selectedGroupUnionId == item.unionId && isRevise"
            >
              <span
                v-for="ele in item.list[0].signupStaff"
                :key="ele.staffId"
                class="name"
              >
                <span class="text">{{ ele.staffName }}</span>
                <span class="icon" @click="detele(ele, item.list[0])">
                  <i class="cubeic-wrong"></i>
                </span>
              </span>
            </div>
          </div>
        </div>

        <!-- 活动管理-有分组-不能报名 -->
        <div
          class="activity-block activity-group"
          v-else-if="
            (currentBaseInfo.identity == '4' ||
              currentBaseInfo.identity == '5') &&
            getActivityInfo.groupStatus == 1
          "
        >
          <p class="title">
            各分会人数
            <span>点击分组可查看报名详情</span>
          </p>
          <div
            class="group-item"
            v-for="(item, index) in signUpGroupList"
            :key="item.unionId"
          >
            <p class="union-name">{{ index + 1 }}、{{ item.unionName }}</p>
            <div class="group-block">
              <div
                v-for="(ele, index3) in item.list"
                :key="ele.groupId"
                class="details"
                @click="checkGroupStaff(ele, item, index3)"
              >
                <p class="group-name">{{ ele.groupName }}</p>
                <p class="group-num">
                  已报
                  <span style="color: #38c7c4">{{
                    ele.signupStaff.length
                  }}</span
                  >人, 可报
                  <span style="color: #ff5959">{{ ele.allowNum }}</span
                  >人
                </p>
                <i
                  class="el-icon-caret-bottom"
                  v-if="selectedGroupId == ele.groupId"
                ></i>
              </div>
            </div>
            <div
              class="names"
              v-if="selectedGroupUnionId == item.unionId && !isReviseGroup"
            >
              <p v-if="staffArr.length == 0">暂无报名人员</p>
              <span
                v-else
                class="text"
                v-for="(ele, index) in staffArr"
                :key="index"
              >
                <span>{{
                  index !== staffArr.length - 1
                    ? ele.staffName + "、"
                    : ele.staffName
                }}</span>
              </span>
            </div>
            <!-- 修改的名字 -->
            <div
              class="names"
              v-if="selectedGroupUnionId == item.unionId && isReviseGroup"
            >
              <span
                v-for="(ele, index2) in staffArr"
                :key="index2"
                class="name"
              >
                <span class="text">{{
                  index2 !== staffArr.length - 1
                    ? ele.staffName + "、"
                    : ele.staffName
                }}</span>
                <span class="icon" @click="detele(ele, item.list[index3])">
                  <i class="cubeic-wrong"></i>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- 去领奖 -->
      <div class="go-draw-signup" v-if="['1', '2'].includes(isRewarded) || hasAwardedMember==1">
        <button @click="goDraw">
          已获奖,去{{ isRewarded === "1" ? "领取" : "查看" }}
        </button>
      </div>
      <div v-else>
        <!-- footer -->
        <div style="height: 84px; width: 100%" v-if="btnHidden()"></div>
        <div
          class="sino-welfare-footer sino-welfare-footer2"
          v-if="btnHidden()"
        >
          <!-- 0未开始1进行中2已结束 currentBaseInfo.identity!='2'-->
          <button class="save-btn-new" @click="update()">
            {{ enrollText }}
          </button>
          <button
            :class="[
              'save-btn-new',
              enrollText == '完成' ? 'save-btn-new-disabled' : '',
            ]"
            @click="enroll()"
          >
            报名
          </button>
        </div>
      </div>

      <!-- 报名人员选择 -->
      <div class="select-popole" v-if="open">
        <pepole
          @back="close"
          @saveSignup="saveSignup"
          :submitLoadingNow="submitLoading"
          :signupInfo="signupInfo"
          :activityId="getActivityInfo.id"
          :deptId="selDeptId"
          :selectedGroupUnionId="selectedGroupUnionId"
          :signupStaff="signupStaff"
        ></pepole>
      </div>

      <!-- 按科室报名分配 -->
      <div class="select-popole" v-if="openDistrubute">
        <signDistribution
          @goback="closeDistribution"
          :signupInfo="signupInfo"
          :activityId="getActivityInfo.id"
          :deptId="selDeptId"
          :signType="signType"
          :signUpCount="signUpCount"
          @selChange="handleSelChange"
          :selectedGroupUnionId="selectedGroupUnionId"
          :signupStaff="signupStaff"
          :unionListThree="unionListThree"
        ></signDistribution>
      </div>

      <!-- 报名的时候先选择报名类型 弹框-->
      <van-popup
        v-model="signTypeShow"
        :style="{ height: '62%', width: '80%' }"
        round
        closeable
      >
        <div class="sign-type-containter">
          <div class="sign-type-title">请选择报名类型</div>

          <div class="sign-type-ctn">
            <div
              :class="
                signUpType == 'bystaff'
                  ? 'sign-type-item-check'
                  : 'sign-type-item'
              "
              @click="typeClick('bystaff')"
            >
              <div>
                <img src="@/images/peoType.png" alt="" />
              </div>
              <div class="sign-type-text">
                <div class="type-text1">按人员分配</div>
                <div class="type-text2">直接给人员报名</div>
              </div>
            </div>
            <div
              :class="
                signUpType == 'bydept'
                  ? 'sign-type-item-check'
                  : 'sign-type-item'
              "
              @click="typeClick('bydept')"
            >
              <div>
                <img src="@/images/keshiType.png" alt="" />
              </div>
              <div class="sign-type-text">
                <div class="type-text1">按科室分配</div>
                <div class="type-text2">直接给科室报名，由小组长提交人员</div>
              </div>
            </div>
          </div>

          <button class="sign-type-btn" @click="toSignFn">确定</button>
        </div>
      </van-popup>
      <!-- 报名的时候先选择报名类型 弹框-->
    </div>
    <page-none v-if="noData == 'true'"></page-none>
  </div>
</template>
<script type="text/ecmascript-6">
import {
  getActivityInfoForSignup,
  saveSign,
  delSignup,
  getInfoForDeptsLeader,
} from "@/common/api";
import { toast } from "@/common/api/api.js";
import pepole from "../../components/pepole.vue";
import signDistribution from "./signDistrubution.vue";
import { log } from "util";
import activityHeader from "./component/activityHeader";
import activityConfig from "../../centralControl/utils/activityConfig";
import pageNone from "../../components/pageNone";
export default {
  name: "signupActivity",
  data() {
    return {
      activityId: "",
      centralControlId: "",
      status: "",
      isRewarded: "", // 0 代表无奖项，1 代表有获奖 2 代表已经领
      getActivityInfo: {},
      loading: false,
      selected: "",
      groups: [],
      group: "",
      open: false,
      enrollText: "编辑",
      groupLitmit: 0,
      groupsOption: {
        label: "",
      },
      signupInfo: {},
      signupStaffLength: 0,
      currentBaseInfo: JSON.parse(localStorage.getItem("loginInfo")),
      full: false,
      foldBtn: true,
      foldHeight: "160",
      fold: false,
      contentScollHeight: "",
      isRevise: false, // 是否修改-无分组
      isReviseGroup: false, // 是否修改-有分组
      reviseGroupId: "", // 正在修改的组ID
      OverEnrollment: false, // 是否超过最大报名人数 控制按钮是否显示

      nameArr: [],
      isOpen: false, // 活动管理无分组是否展开
      selOpenId: "", // 默认展开的无分组

      signUpGroupList: [], // 管理组报名列表
      selectedGroupId: "", // 管理组报名选中的列表
      selectedGroupUnionId: "", // 管理组报名选中的分会ID
      selectedGroupStaff: [], // 管理组报名选中列表中的人
      staffArr: [],
      signNumbers: "暂无报名人员",

      // 按科室报名
      groupDeptsList: [],
      selDeptId: "",
      signUpGroups: [],
      openDistrubute: false,
      signType: "", //报名类型
      signUpCount: "", // 活动所有报名人员
      canSign: true, // 报名按钮是否展示
      officeData: [], //按科室数据
      signupStaff: [], //已报名的人
      selectUnion: false, //45分会是否选中
      selectedGroup: false, //3有分组
      textList: [],
      textObj: {},
      index3: 0,
      officeCurrent: {}, //分会组长当前选中的科室
      unionListThree: [], //3权限创建的活动，去报名时的科室list
      noData: "", //页面接口返回错误标识
      signTypeShow: false, //报名类型弹框
      signTypeList: [
        {
          img: "@/images/peoType.png",
        },
      ],
      // signTypeStr:'',//报名类型选择
      signUpType: "", //报名类型
      statusText: "您所管理的科室可报人数：",
      deptAllowNum: 0, //科室总共可以报名的人数
      deptPeoplenum: 0, //管理科室的总人数
      firstType: false, //第一次选择类型的时候
      submitLoading: false,
      hasAwardedMember: 2
    };
  },
  created() {
    this.getActivityInfoSignup();
  },
  mounted() {
    // if(this.currentBaseInfo.identity=='3'){
    //   if(this.$route.query.level==2){
    //     this.canSign=false;
    //   }
    // }
  },
  components: {
    pepole,
    signDistribution,
    activityHeader,
    pageNone,
  },
  methods: {
    // 点击--报名类型
    typeClick(type) {
      this.signUpType = type;
      // this.signUpType=='bydept'
    },
    // 报名，修改按钮权限
    btnHidden() {
      const { status } = this.$route.query;
      const { identity } = this.currentBaseInfo;
      let flag = this.currentBaseInfo.identity=='2' && this.isRewarded=='0';
      return status != 2 && identity != 1 && !flag;
      // 0未开始1进行中2已结束 currentBaseInfo.identity!='2'
    },
    // 按科室报名切换
    handleSelChange(data, officeData) {
      if (data.radio && data.radio == "2") {
        (this.openDistrubute = false), (this.open = true);
      }
      this.groupDeptsList = [];
      this.officeData = officeData;
    },
    // 按科室报名相关methods
    getInfoForDeptsLeader() {
      var groupArr = [];
      let data = {
        id: this.$route.query.id,
      };
      getInfoForDeptsLeader(data).then((res) => {
        let list = res.data.deptList;
        // 如果是有分组的情况
        if (this.getActivityInfo.groupStatus == 1) {
          if (list && list.length > 0) {
            list.forEach((item) => {
              if (item.groupList && item.groupList.length > 0) {
                let deptItem = {
                  deptName: item.deptName,
                  deptId: item.deptId,
                  groupList: item.groupList,
                  deptSize: item.deptSize,
                };
                // this.groupDeptsList.push(deptItem);
                groupArr.push(deptItem);
              }
            });
          }
          this.groupDeptsList = groupArr;
        } else {
          if (this.signType === 1) {
            this.groupDeptsList = list;
            // this.groupDeptsList=list.filter((item) => {
            //   return item.groupLimit - Number(item.signedUser&&item.signedUser.length) > 0
            // });
            this.officeCurrent = this.groupDeptsList && this.groupDeptsList[0];
          } else {
            this.groupDeptsList = list;
          }
        }

        setTimeout(() => {
          let num = 0;
          this.groupDeptsList &&
            this.groupDeptsList.length &&
            this.groupDeptsList.forEach((item) => {
              num += item.deptSize;
            });
          this.deptPeoplenum = num;
        }, 0);

        // 初始化选中科室的报名情况
        if (this.selDeptId) {
          this.getSignDetailByGroupId(this.selDeptId);
        } else {
          this.selDeptId = this.groupDeptsList[0].deptId;
          this.getSignDetailByGroupId(this.selDeptId);
        }
      });
    },
    // 管理的科室，可报人数（可报名人数，管理的科室总人数，取小值）
    getPeopleFn() {
      return this.deptAllowNum < this.deptPeoplenum
        ? this.deptAllowNum
        : this.deptPeoplenum;
    },
    // 通过deptId查询报名分组情况
    getSignDetailByGroupId(id) {
      this.groupDeptsList.forEach((item) => {
        if (item.deptId == id) {
          item.checked = false;
          // 无分组数据处理
          if (this.getActivityInfo.groupStatus == 0) {
            this.signUpGroups = item;
          }

          // 重构数据
          if (item.groupList && item.groupList.length > 0) {
            item.groupList.forEach((ele) => {
              ele.maxNum = ele.groupLimit;
              ele.checked = false;
            });
            this.signUpGroups = item.groupList;
          }
        }
      });
    },
    // 科室点击事件
    handleDeptsChange(deptId, item) {
      this.officeCurrent = item;
      // unionId
      this.selectedGroupUnionId = item.deptId;
      this.isRevise = false;
      this.selDeptId = deptId;
      this.OverEnrollment = false;
      this.reviseGroupId = "";
      this.signupInfo = {};
      this.getSignDetailByGroupId(deptId);
    },

    selectGroupByDept(item) {
      this.signupStaff = item.signedUser;
      let arr = [];
      this.signUpGroups.forEach((res) => {
        res.checked = false;
        if (item.groupId == res.groupId) {
          res.checked = true;
        }
        arr.push(res);
      });
      this.signUpGroups = arr;
      this.signupInfo = item;
      if (this.currentBaseInfo.identity == 2) {
        // if (item.signedUser.length == item.maxNum) {
        // this.OverEnrollment = true;
        // toast(this, "这组报名人数已满", "error");
        // return;
        // } else {
        this.OverEnrollment = false;
        // }
      } else {
        // if (item.signupStaff.length == item.maxNum) {
        // this.OverEnrollment = true;
        // toast(this, "这组报名人数已满", "error");
        // return;
        // } else {
        this.OverEnrollment = false;
        // }
      }
    },

    // 活动管理无分组
    checkClose(id) {
      this.selectedGroupUnionId = id;
    },
    hiddenNames(id) {
      if (id == this.selectedGroupUnionId) {
        this.selectedGroupUnionId = "";
      }
    },

    handleNamesToArr(arr) {
      let namesArr = [];
      arr.forEach((item) => {
        namesArr.push(item.staffName);
      });
      return namesArr;
    },

    // 活动管理有分组
    checkGroupStaff(item2, item, index3) {
      this.enrollText = "编辑";
      this.isReviseGroup = false;
      this.index3 = index3;
      this.signupInfo = item2;
      this.signupStaff = item2.signupStaff;
      this.staffArr = [];
      this.selectedGroupId = item2.groupId;
      this.selectedGroupUnionId = item.unionId;
      // 45对于3报名的有分组的------科室分配的list赋值
      this.unionListThree = [
        {
          deptName: item.unionName,
          totalNum: item.totalNum,
          deptId: item.unionId,
          groupAndNum: item.list[index3].maxNum || 0,
        },
      ];
      this.signUpGroupList.forEach((item) => {
        item.list.forEach((ele) => {
          if (ele.groupId == item2.groupId) {
            this.selectedGroupStaff = ele.signupStaff;
            if (this.selectedGroupStaff) {
              this.selectedGroupStaff.forEach((item) => {
                this.staffArr.push({
                  staffId: item.staffId,
                  staffName: item.staffName,
                });
              });
            }
          }
        });
      });
    },

    // 分会组长无分组情况下删除人员
    deleteByGroupLeader(item) {
      let totalArr = this.signUpGroups.signedUser;
      this.$createDialog({
        type: "confirm",
        title: "提示",
        icon: "cubeic-alert",
        content: `是否从该活动中删除${item.staffName}?`,
        onConfirm: () => {
          for (let i = 0; i < totalArr.length; i++) {
            if (totalArr[i].staffId == item.staffId) {
              totalArr.splice(i, 1);
            }
          }
          delSignup({
            activityId: this.$route.query.id,
            staffId: item.staffId,
            groupId: this.reviseGroupId,
          }).then((res) => {
            if (res.code == 200) {
              toast(this, res.message);
            } else {
              toast(this, res.message, "error");
            }
          });
        },
      }).show();
    },

    detele(item, groupInfo) {
      let identity = this.currentBaseInfo.identity;
      const { groupStatus } = this.getActivityInfo;
      let totalArr =
        this.currentBaseInfo.identity == 2
          ? groupInfo.signedUser
          : groupInfo.signupStaff;
      this.$createDialog({
        type: "confirm",
        title: "提示",
        icon: "cubeic-alert",
        content: `是否从该活动中删除${item.staffName}?`,
        onConfirm: () => {
          for (let i = 0; i < totalArr.length; i++) {
            if (totalArr[i].staffId == item.staffId) {
              totalArr.splice(i, 1);
            }
          }
          groupInfo.signupStaff = totalArr;
          this.signUpGroups.forEach((item) => {
            if (item.groupId == groupInfo.groupId) {
              item.signedUser = totalArr;
            }
          });

          let groupId = this.reviseGroupId;
          groupId =
            groupId && groupId.indexOf("_") >= 0
              ? groupId.split("_")[0]
              : groupId;

          delSignup({
            activityId: this.$route.query.id,
            staffId: item.staffId,
            groupId: groupId,
          }).then((res) => {
            if (res.code == 200) {
              this.signupStaffLength = totalArr.length;
              if (this.signupStaffLength <= groupInfo.maxNum) {
                this.OverEnrollment = false;
              }
              toast(this, res.message);
              if (identity == "4" || identity == "5")
                this.getActivityInfoSignup();
            } else {
              toast(this, res.message, "error");
            }
          });
        },
      }).show();
    },

    getActivityInfoSignup() {
      this.loading = true;
      getActivityInfoForSignup({
        id: this.$route.query.id,
        officeId: this.currentBaseInfo.unionId,
        version: 1, // 管理组有分组的接口，新添加的标志位
      }).then((res) => {
        if (res.code == 200) {
          this.noData = "false";
          this.loading = false;
          res.data.content = res.data.content
            .replace(new RegExp("&lt;", "g"), "<")
            .replace(new RegExp("&quot;", "g"), "")
            .replace(new RegExp("&gt;", "g"), ">");

          // 处理展开与收起的逻辑
          // this.$nextTick(()=>{
          //   let actualheight = this.$refs.fold.offsetHeight;
          //   let scrollHeight = this.$refs.fold.scrollHeight;
          //   this.contentScollHeight = scrollHeight;
          //   if (scrollHeight <= actualheight) {
          //     this.foldBtn = false;
          //   }
          // })

          // 新的活动头部
          let {
            id,
            startTime,
            endTime,
            name,
            content,
            status,
            templateName,
            creatorOfficeLevel,
            isRewarded,
          } = res.data;
          this.activityId = id;
          this.centralControlId = creatorOfficeLevel;
          this.status = status;
          this.isRewarded = isRewarded;

          this.hasAwardedMember = res.data.hasAwardedMember;
          //特殊情况
          if(this.currentBaseInfo.identity=='2' && isRewarded=='0'){
            this.hasAwardedMember = 2
          }
          
          // 起止时间
          startTime =
            startTime && startTime.split(" ") && startTime.split(" ")[0];
          endTime = endTime && endTime.split(" ") && endTime.split(" ")[0];
          let during = startTime + " 至 " + endTime;
          // 主办单位
          let levelObj = {
            1: "工会",
            2: "分会",
          };
          // 头部信息
          this.textList = [
            { label: "主办单位", value: levelObj[creatorOfficeLevel] },
            { label: "活动时间", value: during },
            { label: "活动类型", value: "报名活动", color: "#29BEBC" },
            { label: "活动模板", value: templateName },
          ];
          this.textObj = {
            title: name,
            status: status,
            statusName: activityConfig.statueObj[status],
            content: content,
          };
          // 新的活动头部

          this.getActivityInfo = res.data;
          let groupStatus = res.data.groupStatus;

          if (groupStatus == 1) {
            this.group = "有";
          } else {
            this.group = "无";
          }

          // 无分组的情况
          if (groupStatus == 0) {
            let signData = res.data.groupList[0];
            this.signupStaff = res.data.groupList[0].signupStaff;
            this.signType = signData.signupByDept;
            this.signUpCount = signData.signupSum; // 活动所有的报名人员
          }

          // 如果是按人员分配，且已经报了名，分会组长角色，只展示报名人员，不能报名
          if (
            this.signType == 0 &&
            this.currentBaseInfo.identity == "2" &&
            this.signUpCount > 0
          ) {
            this.canSign = false;
          }

          this.groups = res.data.groupList;
          // 报名人员处理
          this.signNumbers = this.groupNames(this.getActivityInfo);
          // 管理组有分组的情况下初始数据
          if (
            this.getActivityInfo.signUpInfoByGroup &&
            this.getActivityInfo.signUpInfoByGroup.length > 0
          ) {
            let signUpData = this.getActivityInfo.signUpInfoByGroup;
            // 不展示全为0的数据
            this.signUpGroupList = signUpData.filter((item) => {
              if (item.list && item.list.length > 0) {
                return item;
              }
            });

            if (!this.selectedGroupUnionId)
              this.selectedGroupUnionId = this.signUpGroupList[0].unionId;
            // 3登录的时候，对自己创建的活动，不传unionID，直接获取登录信息里的
            if (this.currentBaseInfo.identity == "3")
              this.selectedGroupUnionId = null;

            //分会默认选中第一个组
            let _index1 = this.signUpGroupList.findIndex((item) => {
              return item.unionId == this.selectedGroupUnionId;
            });
            _index1 = _index1 < 0 ? 0 : _index1;
            let index3 = this.index3 ? this.index3 : 0;

            this.selectUnion = true;
            const chosed =
              this.signUpGroupList && this.signUpGroupList[_index1];
            chosed.checked = true;
            this.signupInfo = chosed.list && chosed.list[index3];
            this.signupStaff = this.signupInfo.signupStaff;

            // 45对于3报名的有分组的------科室分配的list赋值
            this.unionListThree = [
              {
                deptName: chosed.unionName,
                totalNum: chosed.totalNum,
                deptId: chosed.unionId,
                groupAndNum: chosed.list[0].maxNum || 0,
              },
            ];

            if (!this.selectedGroupId)
              this.selectedGroupId = this.signUpGroupList[0].list[0].groupId;

            this.selectedGroupStaff =
              this.signUpGroupList[_index1].list[index3].signupStaff;
            this.staffArr = [];
            if (this.selectedGroupStaff) {
              this.selectedGroupStaff.forEach((item) => {
                this.staffArr.push({
                  staffId: item.staffId,
                  staffName: item.staffName,
                });
              });
            }
          }

          // 无分组处理
          if (
            this.getActivityInfo.groupStatus == 0 &&
            this.currentBaseInfo.identity == 3
          ) {
            const groupList = this.getActivityInfo.groupList[0];
            if (groupList) {
              this.signupStaffLength = groupList.signupStaff
                ? groupList.signupStaff.length
                : 0;
              this.signupInfo = groupList;
              // 无分组状态下
              if (this.signupStaffLength >= groupList.maxNum) {
                this.OverEnrollment = true;
                this.open = false;
                this.full = false;
              }
            }
          }
          // 计算限制人数值
          let groupArr = [];
          this.groupLitmit = this.getActivityInfo.maxNum;

          // 如果是分会主席可以报名计算grouplist中的值，如果是工会主席计算signUpInfoByGroup
          // if(this.currentBaseInfo.identity=='3'){
          //   this.groups.forEach(item => {
          //     item.checked = false;
          //     groupArr.push(item.groupName);
          //     this.groupLitmit += parseInt(item.maxNum);
          //   });
          // }else{
          //   res.data.signUpInfoByGroup.forEach(item => {
          //     if(item.list&&Array.isArray(item.list)){
          //       item.list.forEach(ele => {
          //         this.groupLitmit +=ele.maxNum;
          //       })
          //     }
          //   })
          // }

          let groupList = res.data.groupList;
          let num = 0;
          groupList &&
            groupList.length &&
            groupList.forEach((item, index) => {
              num +=
                Number(item.allowNum) == "NAN" ? 0 : parseInt(item.allowNum);
            });
          this.deptAllowNum = num;

          // 分会组长报名初始化数据
          if (this.currentBaseInfo.identity == "2") {
            this.getInfoForDeptsLeader();
          }
        } else {
          this.noData = "true";
          this.loading = false;
          // toast(this, res.message, "error");
          // setTimeout(() => {
          //   this.$router.go(-1);
          // }, 1000);
        }
      });
    },

    getStaff(arr) {
      let staffArr = [];
      arr.forEach((item) => {
        staffArr.push(item.staffName);
      });
      return staffArr.join("、");
    },
    getStaffId(arr) {
      let staffArr = [];
      arr.forEach((item) => {
        staffArr.push(item.staffId);
      });
      return staffArr.join("、");
    },
    toggleFlod() {
      this.foldHeight = "";
      this.fold = !this.fold;
      if (!this.fold) {
        this.foldHeight = "160";
      }
    },
    // 45权限无分组情况点击分会
    selectGroupManage(current) {
      this.selDeptId = current.unionId;
      // 45对于3报名的无分组的------科室分配的list赋值
      this.unionListThree = [
        {
          deptName: current.unionName,
          totalNum: current.totalNum,
          deptId: current.unionId,
          groupAndNum: current.list[0].maxNum || 0,
        },
      ];
      let arr = [];
      var signUpGroupList = this.signUpGroupList;
      for (var a = 0; a < signUpGroupList.length; a++) {
        var item = signUpGroupList[a];
        item.checked = item.unionId == current.unionId;
        arr.push(item);
      }
      this.signUpGroupList = arr;
      this.selectedGroupUnionId = current.unionId;
      this.selectUnion = true;
      this.signupStaff = current.list && current.list[0].signupStaff;
      this.signupInfo = current.list && current.list[0];
    },
    selectGroup(item) {
      this.selectedGroup = true;
      this.signupStaff = item.signupStaff; //已报名的人
      let selGroup = this.groups.filter((ele) => ele.groupId == item.groupId);
      this.signType = selGroup[0].signupByDept;
      this.signUpCount = selGroup[0].signupSum;

      let arr = [];
      this.groups.forEach((res) => {
        res.checked = false;
        if (item.groupId == res.groupId) {
          res.checked = true;
        }
        arr.push(res);
      });
      this.groups = arr;
      this.signupInfo = item;
      if (this.currentBaseInfo.identity == "2") {
        if (item.signedUser.length == item.maxNum) {
          this.OverEnrollment = true;
          toast(this, "这组报名人数已满", "error");
          return;
        } else {
          this.OverEnrollment = false;
        }
      } else {
        if (item.signupStaff.length == item.maxNum) {
          this.OverEnrollment = true;
          toast(this, "这组报名人数已满", "error");
          return;
        } else {
          this.OverEnrollment = false;
        }
      }
    },
    // 获取报名类型
    tosignUpFn() {
      this.isRevise = false;
      if (this.$route.query.status == 2) {
        this.OverEnrollment = true;
        toast(this, "当前活动已结束,无法报名", "error");
        return;
      }

      // 可以报名的情况下，必须有选择组别
      let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
      const { identity } = loginInfo;

      if (identity == "4" || identity == "5") {
        // 45权限无分组时，先选分会
        if (!this.selectUnion && this.getActivityInfo.groupStatus == 0)
          return toast(this, "请先选择分会", "error");
        if (this.signupInfo.allowNum <= 0)
          return toast(this, "当前可报人数为0", "error");
        setTimeout(() => {
          this.toSignTypeFn();
        }, 1);
        // this.openDistrubute = true; // 45可以按照分会/人员报名
      } else {
        if (loginInfo.identity == "3") {
          console.log("333", this.selectedGroup, this.getActivityInfo);
          if (!this.selectedGroup && this.getActivityInfo.groupStatus == 1) {
            toast(this, "请选择分组", "error");
            return;
          } else {
            // if(this.getPeopleFn()==0)return this.$message.error("当前可报名人数为0");
            // setTimeout(()=>{this.toSignTypeFn();},1)

            if (this.signupInfo.signupStaff.length >= this.signupInfo.maxNum) {
              toast(this, "这组报名人数已满", "error");
              return;
            } else {
              // this.openDistrubute = true;
              setTimeout(() => {
                this.toSignTypeFn();
              }, 1);
            }
          }
        } else {
          // 有分组的情况报名
          if (this.getActivityInfo.groupStatus == 1) {
            if (!this.signupInfo.groupId) {
              toast(this, "请选择分组", "error");
              return;
            } else {
              if (this.currentBaseInfo.identity == 2) {
                let index = this.signUpGroups.findIndex((item) => {
                  return item.checked;
                });
                if (index < 0) return toast(this, "请选择分组", "error");
                // if (
                //   this.signupInfo.signedUser.length >= this.signupInfo.maxNum
                // ) {
                //   toast(this, "这组报名人数已满", "error");
                //   return;
                // } else {
                this.OverEnrollment = false;
                this.open = true;
                this.full = true;
                // }
              } else {
                if (
                  this.signupInfo.signupStaff.length >= this.signupInfo.maxNum
                ) {
                  toast(this, "这组报名人数已满", "error");
                  return;
                } else {
                  this.OverEnrollment = false;
                  this.open = true;
                  this.full = true;
                }
              }
            }
          } else if (this.getActivityInfo.groupStatus == 0) {
            // 无分组，分会组长报名
            if (loginInfo.identity == "2") {
              if (this.getPeopleFn() == 0)
                return this.$message.error("当前可报名人数为0");
              if (
                this.signUpGroups.groupLimit <=
                this.signUpGroups.signedUser.length
              ) {
                // this.OverEnrollment = true;
                // return toast(this, "报名人数已满", "error");
              }
            }
            this.open = true;
            this.full = true;
          }
        }
      }
    },

    //点击报名
    enroll() {
      if (this.enrollText == "完成") return;
      let params = {
        activityId: this.getActivityInfo.id,
        officeId: this.selectedGroupUnionId || this.currentBaseInfo.unionId,
      };
      var { groupId } = this.signupInfo;
      groupId =
        groupId && groupId.indexOf("_") >= 0 ? groupId.split("_")[0] : groupId;
      if (this.getActivityInfo.groupStatus == 1) params.groupId = groupId;
      this.centralControl.axios.centralControl(
        "getSignUpType",
        (res) => {
          if (res.code == 200) {
            if (JSON.stringify(res.data) != "{}") {
              this.signUpType = res.data;
              const typeObj = {
                bystaff: "2",
                bydept: "1",
              };
              // this.signRadio=typeObj[this.signUpType];
            } else {
              this.signUpType = "";
            }
            // 去报名
            this.tosignUpFn();
          } else {
            this.$message.error(res.message);
          }
        },
        params
      );
    },
    goDraw() {
      this.$router.push({
        path: "/activityDetail",
        query: {
          activityId: this.activityId,
          source: "me1",
          status: this.status,
          level: this.centralControlId,
          hasAwardedMember: this.hasAwardedMember
        },
      });
    },
    // 根据报名类型去不同页面
    toSignTypeFn() {
      // 还没有按类型分配时
      if (this.signUpType == "") {
        this.firstType = true;
        return (this.signTypeShow = true);
      }
      this.commonSignFn();
    },
    // 选了类型后去不同类型的报名页面
    toSignFn() {
      if (this.signUpType == "")
        return toast(this, "请先选择报名类型", "error");
      this.commonSignFn();
    },
    commonSignFn() {
      this.signTypeShow = false;
      if (this.signUpType == "bydept") {
        // 按科室报名时
        this.openDistrubute = true;
      } else if (this.signUpType == "bystaff") {
        // 按人员报名时
        this.open = true;
      }
    },
    // 修改事件
    update() {
      this.isRevise = false;
      this.isReviseGroup = false;
      const { groupStatus } = this.getActivityInfo;

      if (this.enrollText == "完成") {
        this.enrollText = "编辑";

        // 3权限清除选中的分组
        this.groups.forEach((res) => {
          res.checked = false;
        });
        this.selectedGroup = false;
        this.reviseGroupId = "";
        // 3权限清除选中的分组

        //45权限的时候编辑完成后--清空选中状态(无分组)
        // this.selectedGroupUnionId='';
        // let arr=[];
        // for(var a =0;a<this.signUpGroupList.length;a++){
        //   var item = this.signUpGroupList[a];
        //   item.checked = false;
        //   arr.push(item);
        // }
        // this.signUpGroupList=arr;
        // this.selectUnion='';
        //45权限的时候编辑完成后--清空选中状态

        // 如果是分会组长(刷新)
        if (this.currentBaseInfo.identity == "2") {
          this.getInfoForDeptsLeader();
          this.getActivityInfoSignup();
        } else if (this.currentBaseInfo.identity == "3") {
          this.getActivityInfoSignup();
        }
      } else {
        let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
        const { identity } = loginInfo;
        if (identity == "4" || identity == "5") {
          // 45权限无分组时，先选分会
          if (!this.selectUnion && groupStatus == 0)
            return toast(this, "请先选择分会", "error");
          if (groupStatus == 1) {
            // 有分组的编辑
            this.reviseGroup(this.signupInfo);
          } else {
            // 无分组的编辑
            this.reviseMore(this.signupInfo.signupStaff);
          }
        } else if (identity == "3") {
          // 3权限有分组时，先选分组
          if (!this.selectedGroup && groupStatus == 1)
            return toast(this, "请选择分组", "error");
          if (groupStatus == 1) {
            // 有分组的编辑
            this.reviseGroup(this.signupInfo);
          } else {
            // 无分组的编辑
            this.revise(this.getActivityInfo);
          }
        } else {
          if (groupStatus == 1) {
            // 有分组的编辑
            let index = this.signUpGroups.findIndex((item) => {
              return item.checked;
            });
            if (index < 0) return toast(this, "请选择分组", "error");
            this.reviseGroup(this.signupInfo);
          } else {
            // 无分组的编辑
            this.reviseMore(this.officeCurrent.signedUser);
          }
        }
      }
    },
    reviseMore(signedUser) {
      if (!signedUser || signedUser.length == 0)
        return toast(this, "当前分组没有报名人员", "error");
      this.enrollText = "完成";
      this.isRevise = true;
    },
    revise(item) {
      if (item.groupId) {
        if (item.signupStaff.length == 0) {
          toast(this, "当前分组不可修改", "error");
          return;
        } else {
          this.enrollText = "完成";
          this.isRevise = true;
        }
      } else {
        if (this.groupLitmit == 0) {
          toast(this, "当前分组不可修改");
          return;
        }

        let groupList = this.getActivityInfo.groupList[0];
        if (groupList.signupStaff.length == 0) {
          toast(this, "当前分组没有报名人员", "error");
        } else {
          this.enrollText = "完成";
          this.isRevise = true;
        }
      }
    },

    // 需报名-无分组 修改后
    reviseOk() {
      this.isRevise = false;
    },
    reviseGroupOK() {
      this.reviseGroupId = "";
    },

    // 有分组的修改
    reviseGroup(item) {
      if (item.groupId) {
        if (this.currentBaseInfo.identity == 2) {
          if (item.signedUser.length == 0) {
            toast(this, "当前分组暂无报名人员，不可修改", "error");
            return;
          } else {
            this.isReviseGroup = true;
            this.reviseGroupId = item.groupId;
            this.selectedGroupUnionId = item.unionId;
            this.enrollText = "完成";
          }
        } else {
          if (item.signupStaff.length == 0) {
            toast(this, "当前分组暂无报名人员，不可修改", "error");
            return;
          } else {
            this.isReviseGroup = true;
            this.reviseGroupId = item.groupId;
            // this.selectedGroupUnionId=item.unionId;
            this.enrollText = "完成";
          }
        }
      } else {
        let groupList = this.getActivityInfo.groupList[0];
        if (groupList.signupStaff.length == 0) {
          toast(this, "当前分组没有报名人员", "error");
        } else {
          this.isReviseGroup = true;
          this.reviseGroupId = item.groupId;
          this.selectedGroupUnionId = item.unionId;
          this.enrollText = "完成";
        }
      }
    },

    close() {
      this.open = false;
      this.full = false;
    },
    closeDistribution(data) {
      if (data && data.saveDept) {
        this.signType = 1; // 将signType置为按科室报名
        toast(this, "按科室报名保存成功", "success");
      }
      this.open = false;
      this.openDistrubute = false;
      this.full = false;
      this.selectedGroup = false;
      this.getActivityInfoSignup();
    },
    groupNames(data) {
      if (data.groupList) {
        let arr = [];
        data.groupList[0].signupStaff.forEach((item) => {
          arr.push(item.staffName);
        });
        return arr.join("、");
      } else {
        return null;
      }
    },
    saveSignup(option, currentDepartment, signedList) {
      if (
        this.signUpGroups.groupLimit < option.length &&
        this.signUpType != "bystaff" &&
        this.currentBaseInfo.identity != "2"
      ) {
        let overNum = option.length - this.signUpGroups.groupLimit;
        toast(
          this,
          `可报${this.signUpGroups.groupLimit}人，已超出${overNum}人，不能报名`,
          "error"
        );
        return;
      }
      currentDepartment = currentDepartment
        ? currentDepartment
        : this.unionListThree && this.unionListThree[0].deptId;
      // option=option.filter(item=>{return item.check})//删除选中的
      let length = option.length + signedList.length; //之前报名过的人数+这次选择的人数
      //按科室分配后，才能按照人员分配
      let flag = false;
      let flag2 = false;
      this.officeData &&
        this.officeData.map((item) => {
          if (item.deptId == currentDepartment && item.groupAndNum == 0)
            flag = true;
          if (
            item.deptId == currentDepartment &&
            option.length > item.groupAndNum
          )
            flag2 = true;
        });
      // if (flag)
      //   return toast(this, `该科室暂未分配人数，请先按科室分配！`, "error");
      // if (flag2) return toast(this, `不能大于该科室分配的总人数！！`, "error");

      let num = 0; //该科室已分配的人数
      // for(let i=0;i<this.officeData.length;i++){
      for (let j = 0; j < this.signupStaff.length; j++) {
        if (currentDepartment == this.signupStaff[j].deptId) {
          num++;
        }
      }
      // }
      let num2 = 0; //按照科室分配的人数
      this.officeData &&
        this.officeData.map((item) => {
          if (item.deptId == currentDepartment) num2 = item.groupAndNum;
        });
      // 分会组长
      if (this.currentBaseInfo.identity == 2) {
        // 有分组
        let len = this.signupInfo.groupLimit;
        // let len = this.signupInfo.groupLimit - Number(this.signupInfo.signedUser&&this.signupInfo.signedUser.length)
        num2 = len;
      }
      // if (option.length > num2 - num)
      // return toast(
      //   this,
      //   `该科室已分配${num}人,现可报名人数为${num2 - num}`,
      //   "error"
      // );

      var { groupId } = this.signupInfo;
      groupId =
        groupId && groupId.indexOf("_") >= 0 ? groupId.split("_")[0] : groupId;

      this.loading = true;

      var data = {
        activityId: this.getActivityInfo.id, //活动ID
        groupId: groupId, //分组ID
        unionId: this.selectedGroupUnionId || this.currentBaseInfo.unionId,
        groupName: this.signupInfo.groupName, //分组名称
        maxNum: this.signupInfo.maxNum
          ? this.signupInfo.maxNum
          : this.groupLitmit,
        groupStatus: this.getActivityInfo.groupStatus, //此活动是否分组（否：0； 是：1；）
        staffListJson: JSON.stringify(option), //职工集合json
        action: this.currentBaseInfo.identity == "2" ? "signUpByDept" : "",
        deptId: this.selDeptId,
      };
      let params = {
        activityId: this.getActivityInfo.id,
        unionId: this.selectedGroupUnionId || this.currentBaseInfo.unionId,
      };
      if (this.getActivityInfo.groupStatus == 1) params.groupId = groupId;
      if (!this.signUpType || this.firstType) {
        // 还没有报名过
        this.centralControl.axios.centralControl(
          "signUpByStaff",
          (res) => {
            if (res.code == 200) {
              this.saveSignupFn(data);
              this.submitLoading = true;
            } else {
              this.loading = false;
            }
          },
          params
        );
      } else {
        // 第一次报名
        this.saveSignupFn(data);
      }
    },
    // 按人员报名方法
    saveSignupFn(data) {
      saveSign(data).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          toast(this, res.message);
        } else {
          toast(this, res.message, "error", 2000);
        }
        this.open = false;
        this.full = false;
        this.selectedGroup = false;
        // 如果是分会组长
        if (this.currentBaseInfo.identity == "2") {
          this.getInfoForDeptsLeader();
          this.getActivityInfoSignup();
        } else {
          this.getActivityInfoSignup();
        }
        this.signupInfo.groupId = "";
      });
    },
  },
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/detail.styl';

.direct-container .van-popup--round {
  border-radius: 0.2rem !important;
}

.sign-type-containter {
  padding: 20px;

  .sign-type-title {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #353535;
    margin-bottom: 10px;
  }

  .sign-type-ctn {
    margin: 30px 0;
  }

  .sign-type-item, .sign-type-item-check {
    border: 2px solid #E5E5E9;
    margin-top: 20px;
    padding: 14px 20px;
    display: flex;
    align-items: center;

    img {
      width: 30px;
      margin-right: 20px;
    }

    .sign-type-text {
      .type-text1 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #353535;
      }

      .type-text2 {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #B1B1B1;
        margin-top: 10px;
        line-height: 16px;
      }
    }
  }

  .sign-type-item-check {
    border: 2px solid #29BDBB;
  }

  .sign-type-btn {
    width: 100%;
    height: 44px;
    background: #29BDBB;
    border-radius: 6px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    // margin-top: 20px;
  }
}

.direct_my {
  .cube-checkbox-wrap {
    padding-top: 20px;
  }

  .group-item-flex {
    align-items: center;
  }
}

.group-detail {
  display: flex;
  flex-direction: row;
  padding: 10px 10px 0 10px;

  >span {
    width: 70px;
    color: #acacb7;
    font-size: 16px;
  }

  >div {
    flex: 1;
    display: flex;
    flex-wrap: wrap;

    p {
      margin: 0 5px 10px 0;
    }
  }
}

.dept-list {
  white-space: nowrap;
  margin-top: 20px;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;

  span {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    border: 1px solid #e5e5e5;
    padding: 0px 10px;
  }

  span.active {
    background: rgba(56, 199, 196, 1);
    color: #fff;
  }
}

.sino-welfare-footer {
  background: #fff;
  position: absolute;
  bottom: 0;
  padding: 10px 0;
}

.names {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
  font-family: PingFang SC;
  color: rgba(53, 53, 53, 1);
  line-height: 28px;
  max-height: 180px;
  overflow: scroll;

  .nameDefault {
  }

  .name {
    font-size: 14px;
    font-family: PingFang SC;
    color: rgba(53, 53, 53, 1);
    line-height: 28px;
    margin-right: 20px;

    .text {
      color: rgba(136, 136, 136, 1);
      padding-right: 0.3rem;
    }

    .icon {
      color: #B2B2B2;

      i {
        font-size: 14px;
      }
    }
  }
}

.signup {
  background: #F0F0F4;
  overflow-y: scroll;
  overflow-x: hidden;
  height: calc(100vh - 80px);

  .direct-top {
    background: #fff;
  }

  .direct-group {
    margin-top: 0.5rem;
    background: #fff;
    padding: 5px 0 5px 20px;
    border-bottom: 1px solid rgba(229, 229, 229, 1);

    img {
      width: 18px;
      height: 18px;
      margin-right: 6px;
    }

    .group {
      display: flex;
      // justify-content:space-between;
      align-items: center;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      line-height: 28px;
      font-size: 14px;
      padding: 10px 20px 10px 0px;

      .label {
        color: rgba(136, 136, 136, 1);
        font-size: 16px;
        font-weight: 500;
        color: rgba(146, 156, 175, 1);
        line-height: 28px;
        margin-right: 30px;
      }

      .value {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(53, 53, 53, 1);
        line-height: 28px;
      }

      .right-side {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }

    .names {
      font-size: 14px;
      color: rgba(53, 53, 53, 1);
      line-height: 28px;
      max-height: 180px;
      overflow: scroll;
    }

    .number {
      border: 0;
      color: rgba(53, 53, 53, 1);
    }
  }

  .direct-group-person {
    margin-bottom: 0.5rem;
    background: #fff;

    .panel {
      padding: 0.3rem 0.2rem 0 0.2rem;

      .panel-item {
        display: flex;
        padding-bottom: 0.2rem;
        border-bottom: 1px solid rgba(229, 229, 229, 1);
        align-items: flex-start;

        .item-radio {
          flex: 1;
          display: flex;

          .cube-checkbox {
            padding: 0 0.2rem;
          }
        }

        .item-info {
          flex: 7;

          .info-title {
            height: 40px;
            line-height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title {
              color: rgba(53, 53, 53, 1);
              font-size: 16px;
            }

            .limit {
              font-size: 12px;
              color: rgba(178, 178, 178, 1);
            }
          }

          .no-sign {
            font-size: 12px;
            color: rgba(178, 178, 178, 1);
          }

          .pepole {
            color: rgba(153, 153, 153, 1);
          }
        }
      }
    }

    .limit-nogroup {
      text-align: center;
      color: rgba(178, 178, 178, 1);
      font-size: 12px;
    }
  }
}

.go-draw-signup {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 82px;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    width: 45%;
    background: #169BD5;
    height: 50px;
    border-radius: 10px;
    color: #FFF;
    font-family: Noto Sans S Chinese;
    font-weight: 500;
  }

  button[disabled] {
    color: white !important;
    background: #CCC !important;
  }
}

.select-popole {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 200;
  width: 100%;
  height: 100%;
  background: #fff;
}

.sino-revise {
  font-size: 12px;
  color: rgba(56, 199, 196, 1);
  margin-left: 10px;
}

.group-item-flex {
  display: flex;

  .cube-checkbox {
    padding: 0 !important;
  }
}

.cube-checkbox-ui {
  line-height: 0;
  margin-top: 9px;
}

.sino-welfare-footer2 {
  display: flex;
  justify-content: space-around;

  .save-btn-new {
    width: 44%;
    height: 48px;
    line-height: 48px;
    display: inline-block;
    text-align: center;
    border-radius: 52px;
    font-size: 18px;
    font-weight: 500;
    border-radius: 8px;
  }

  .save-btn-new:nth-child(1) {
    border: 1px solid rgba(41, 190, 188, 1);
    background: #FFF;
    color: #29BEBC;
  }

  .save-btn-new:nth-child(2) {
    background: #29BEBC;
    color: rgba(255, 255, 255, 1);
  }

  .save-btn-new-disabled {
    background: rgba(#29BEBC, 0.4) !important;
  }
}
</style>
